import classNames from 'classnames';
import ArrowDown from 'components/shared/arrow-down';
import ArrowUp from 'components/shared/arrow-up';
import { FILTER_ACTION_TYPES } from 'hooks/filterGlobalState/filterReducer';
import CustomCheckbox from 'components/shared/customCheckbox';
import styles from './mobileFilterDropdown.module.scss';

const MobileFilterDropdown = ({
  className,
  filterName,
  options,
  isOptionActive,
  useFilterObject,
}) => {
  const { filterState, updateFilterState, addFilter, removeFilter } = useFilterObject;
  const isOpen = filterState.openedDropdown === filterName;
  const openOrCloseDropdown = () => {
    if (isOpen) updateFilterState({ type: FILTER_ACTION_TYPES.OPENED_DROPDOWN.CLEAR });
    else updateFilterState({ type: FILTER_ACTION_TYPES.OPENED_DROPDOWN.SET, value: filterName });
  };

  const isOptionSelected = option =>
    filterState.selectedFilters?.some(
      filter => filter.id === option.id && filter.value === option.value
    );

  const selectHandler = option => {
    if (isOptionSelected(option)) {
      removeFilter(option);
    } else {
      addFilter(option);
    }
  };

  return (
    <div className={classNames(className, styles.filterSelectWrapper)}>
      <button className={styles.openClose} type="button" onClick={() => openOrCloseDropdown()}>
        <div className={styles.mobileDropdownHeader}>
          <h3 className={styles.filterName}>{filterName}</h3>
          {isOpen ? (
            <ArrowUp width="2.8rem" height="2.8rem" />
          ) : (
            <ArrowDown width="2.8rem" height="2.8rem" />
          )}
        </div>
      </button>
      {isOpen && (
        <div className={styles.mobileDropdownOptions}>
          {options.map(option => (
            // eslint-disable-next-line
            <div
              key={option}
              className={classNames(styles.option, {
                [styles.disabledOption]: !isOptionActive(option),
              })}
              onClick={() => selectHandler(option)}
            >
              <CustomCheckbox checked={isOptionSelected(option)} />
              <h3 className={styles.optionValue}>{option.value}</h3>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileFilterDropdown;
